import { render, staticRenderFns } from "./ReferencesDeadlines.vue?vue&type=template&id=19768794"
import script from "./ReferencesDeadlines.vue?vue&type=script&lang=js"
export * from "./ReferencesDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports